import { init as initI18n } from '@shared/i18n'
import tournament from '@/store/modules/tournament'

const { defaultLanguage } = tournament.state
initI18n({ defaultLanguage })
